<script>
  import {link} from 'svelte-spa-router'
  import active from 'svelte-spa-router/active'

  import Icon from '../../atoms/Icon.svelte';
  import stack from '../../../../public/assets/svg/24/stack.svg';
  import vault from '../../../../public/assets/svg/24/vault.svg';
  import flash from '../../../../public/assets/svg/24/flash.svg';
  import chat from '../../../../public/assets/svg/24/chat.svg';
  import profile from '../../../../public/assets/svg/24/profile.svg';

  // import { curRoute, activeTab } from '../../store';
  
  export let route;

  // function redirectTo(event){
  //   // change current router path
  //   curRoute.set(event.target.pathname);
  //   // reset default tab if set via createModal
  //   activeTab.set(1);
  //   // push the path into web browser history API
  //   // window.history.pushState({path: route.path}, '', window.location.origin + route.path);
  // }
  
</script>

<!-- <a href={route.path} on:click|preventDefault={redirectTo}> -->
<a href={route.path} use:link use:active>
  {#if route.name === 'Feed'}
    <Icon data={stack} fill={'none'}></Icon>
  {:else if route.name === 'Vault' }
    <Icon data={vault} fill={'none'}></Icon>
  {:else if route.name === 'Create'}
    <Icon data={flash} fill={'none'}></Icon>
  {:else if route.name === 'Chat'}
    <Icon data={chat} fill={'none'}></Icon>
  {:else}
    <Icon data={profile} fill={'none'}></Icon>
  {/if}
</a>

<style>

  :global(a.active > svg) {
    fill: #EDF22C;
  }

</style>